<ngx-dropzone #drop (change)="onSelect($event)">
  <ngx-dropzone-label translate>Document.Upload.Drop</ngx-dropzone-label>
  <ngx-dropzone-preview *ngFor="let f of files" [removable]="true" (removed)="onRemove(f)">
    <ngx-dropzone-label>{{ f.name }}</ngx-dropzone-label>
  </ngx-dropzone-preview>
</ngx-dropzone>

<button mat-button (click)="drop.showFileSelector()" class="col-12">{{ 'Document.Upload.Open' | translate }}</button>
